module.exports = __webpack_public_path__ + "static/media/epillax-1.06a50997.jpg";